module.exports = __webpack_public_path__ + "img/38_36.eaeff40a.png";